import script from "./AdminPrayerRequestFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPrayerRequestFeedback.vue?vue&type=script&setup=true&lang=js"

import "./AdminPrayerRequestFeedback.vue?vue&type=style&index=0&id=73e9a378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e9a378"]])

export default __exports__